import { useMatch } from "@/api/services/admin/match";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid } from "@mui/material";
import { MatchInfoItem } from "@/features/match/components/MatchInfoItem";
import { findLabelByValue } from "@/utils/object";
import { useEnum } from "@/api/services/global/enum";
import { styled } from "@mui/system";
import { divider } from "@/theme/colors";
import { getFullAddress } from "@/utils/string";

export const MatchSummary = () => {
  const { data: matchResult, isLoading: isLoadingMatch } = useMatch();
  const { data: contractStatusOptions } = useEnum("EMatchContractStatus");

  const matchData = matchResult?.data;

  const contractStatus = findLabelByValue(contractStatusOptions, matchData?.contractStatus);

  const fullAddress = getFullAddress({
    zipCode: matchData?.zipCode,
    province: matchData?.prefecture,
    municipality: matchData?.city,
    address: matchData?.address,
  });

  return (
    <MatchInnerBox title="基本情報">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MatchInfoItem label="所在地" value={fullAddress} type="textArea" />
        </Grid>
        <Grid item xs={6}>
          <MatchInfoItem label="ステータス" value={contractStatus} />
        </Grid>
        <Grid item xs={3}>
          <MatchInfoItem label="契約プラン" value={matchData?.contractPlan} />
        </Grid>
        <Grid item xs={3}>
          <MatchInfoItem label="課金対象数" value={matchData?.billingCount} type="number" suffix="人" />
        </Grid>
        <Grid item xs={3}>
          <MatchInfoItem label="前月課金数" value={matchData?.prevMonthBillingCount} type="number" suffix="人" />
        </Grid>
        <Grid item xs={3}>
          <MatchInfoItem label="トライアル開始日" value={matchData?.trialStartDate} type="date" />
        </Grid>
        <Grid item xs={3}>
          <MatchInfoItem label="トライアル終了日" value={matchData?.trialEndDate} type="date" />
        </Grid>
        <Grid item xs={3}>
          <MatchInfoItem label="契約日" value={matchData?.contractStartDate} type="date" />
        </Grid>
        <Grid item xs={3}>
          <MatchInfoItem label="解約日" value={matchData?.contractEndDate} type="date" />
        </Grid>
      </Grid>
    </MatchInnerBox>
  );
};

const MatchInnerBox = styled(InnerBox)`
  border: 1px solid ${divider.high};
  padding: 8px;
`;
